import { render, staticRenderFns } from "./riskStatusTable.vue?vue&type=template&id=118536d8&scoped=true&"
import script from "./riskStatusTable.vue?vue&type=script&lang=js&"
export * from "./riskStatusTable.vue?vue&type=script&lang=js&"
import style0 from "./riskStatusTable.vue?vue&type=style&index=0&id=118536d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118536d8",
  null
  
)

export default component.exports